import axios from 'axios'
import { ON_LOGOUT_OKTA,
    ON_LOGOUT_OKTA_ERROR,
    ON_LOGOUT_OKTA_SUCCESS,
    ON_LOGOUT_OAG,
    ON_LOGOUT_OAG_ERROR,
    ON_LOGOUT_OAG_SUCCESS } from '../constants/application'
import { sessionTimeoutLog, sessionTimeoutCleanup } from '../routes'


const onLogoutOkta = () => ({ type: ON_LOGOUT_OKTA })
const onLogoutOktaSuccess = payload => ({ payload, type: ON_LOGOUT_OKTA_SUCCESS })
const onLogoutOktaFailure = payload => ({ payload, type: ON_LOGOUT_OKTA_ERROR })

const onLogoutOAG = () => ({ type: ON_LOGOUT_OAG })
const onLogoutOAGSuccess = payload => ({ payload, type: ON_LOGOUT_OAG_SUCCESS })
const onLogoutOAGFailure = payload => ({ payload, type: ON_LOGOUT_OAG_ERROR })


export const logoutOktaSession = oktaCurrentSession => {
    return async dispatch => {
        if (oktaCurrentSession) {
            dispatch(onLogoutOkta())

            await axios.delete(oktaCurrentSession)
                .then(() => dispatch(onLogoutOktaSuccess()))
                .catch(err => dispatch(onLogoutOktaFailure(err)))
        }
    }
}

export const terminateOAGSession = logoutOAGSession => {
    return async dispatch => {
        if (logoutOAGSession) {
            dispatch(onLogoutOAG())

            fetch(logoutOAGSession, {
                credentials: 'include',
                method: 'GET',
                mode: 'no-cors'
            })
                .then(() => dispatch(onLogoutOAGSuccess('Success')))
                .catch(err => dispatch(onLogoutOAGFailure(err)))
        }
    }
}

export const logSessionTimeoutEvent = async dataObj => {
    try {
        const response = await axios.post(sessionTimeoutLog, { encObj: dataObj }, {
            headers: {
                'Content-Type': 'application/json'
            }
        })

        return response.data

    } catch (error) {
        console.error('Failed to log session timeout:', error)
        throw error
    }
}

export const cleanupSessionTimeoutEvent = async dataObj => {
    try {
        const response = await axios.post(sessionTimeoutCleanup, { encObj: dataObj }, {
            headers: {
                'Content-Type': 'application/json'
            }
        })

        return response.data

    } catch (error) {
        console.error('Failed to cleanup session timeout:', error)
        throw error
    }
}
